"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _axios = require("axios");
var _underscore = require("underscore");
var _rxjs = require("rxjs");
var _api = _interopRequireDefault(require("@shoflo/api.v2-client"));
var _StudioLogger = require("@studio/logger/StudioLogger");
var _operators = require("rxjs/operators");
var _ModalTypes = require("@studio/constants/ModalTypes");
var _types = require("../../actions/types/types.generic");
var _startUILoading = _interopRequireDefault(require("../../actions/loading/startUILoading"));
var _stopUILoading = _interopRequireDefault(require("../../actions/loading/stopUILoading"));
var _showModal = _interopRequireDefault(require("../../actions/modal/showModal/showModal"));
var _showNotification = _interopRequireDefault(require("../../actions/notification/showNotification"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var logger = new _StudioLogger.StudioLogger('studio-redux');
var _location = (window || {}).location,
  hostname = _location.hostname,
  protocol = _location.protocol,
  port = _location.port;
var apiClient = new _api["default"]({
  endpoint: "".concat(protocol, "//").concat(hostname, ":").concat(port),
  proxy: true
});
var cancel$ = new _rxjs.Subject();
function apiMiddleware(store) {
  return function (next) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(action) {
        var config;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              /* Adding this to handle instances where we need to pass down
               args to the middleware after a success or failure in action
              */
              config = {};
              if (action.config) {
                config = _objectSpread({}, action.config);
              }
              /**
               * If we get a cancel signal, we tell the cancel$ subject
               */
              if (!(action.type === _types.GLOBAL_REQ_CANCEL)) {
                _context.n = 1;
                break;
              }
              cancel$.next();
              return _context.a(2, next(action));
            case 1:
              if (action.loadingKey) {
                store.dispatch((0, _startUILoading["default"])(action.loadingKey));
              }

              /**
               * If it doesn't have a request method, next!
               */
              if (action.request) {
                _context.n = 2;
                break;
              }
              return _context.a(2, next(action));
            case 2:
              (0, _rxjs.from)([action]).pipe((0, _operators.mergeMap)(function (action) {
                return (0, _rxjs.from)(action.request(apiClient)).pipe((0, _operators.catchError)(function (error) {
                  return (0, _rxjs.of)({
                    error: error
                  });
                }));
              }),
              //If we get any values from cancel$, stop
              (0, _operators.takeUntil)(cancel$)).subscribe(function (result) {
                if (result && result.error) {
                  var _error$response;
                  var error = result.error;
                  if ((error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 401) {
                    store.dispatch((0, _showModal["default"])(_ModalTypes.UNAUTHORIZED_ERROR));
                  }
                  var networkError = error instanceof _axios.AxiosError && error.code === _axios.AxiosError.ERR_NETWORK;

                  // altering the log for the situation where there is no error object. We have seen these in cases of XHR aborts without clear indication of the cause.
                  // The result is very large and does not often contain useful info but it is a last resort for debugging
                  if (Object.keys(error).length === 0) {
                    console.error("Api Middleware - ".concat(action.type, "_FAILURE - error was empty"), {
                      response: result
                    });
                  } else {
                    console.error("Api Middleware - ".concat(action.type, "_FAILURE"), {
                      isNetworkError: networkError,
                      actionType: action.type,
                      requestError: error
                    });
                  }
                  store.dispatch({
                    type: "".concat(action.type, "_FAILURE"),
                    payload: result
                  });
                  if (networkError && !notificationDisplayed) {
                    showNetworkErrorNotification(store.dispatch);
                  }
                  if (action.loadingKey) {
                    store.dispatch((0, _stopUILoading["default"])(action.loadingKey));
                  }
                  return;
                }
                if (!result) {
                  console.warn("Api Middleware - No result returned for ".concat(action.type));
                }
                logger.info("Api Middleware - ".concat(action.type, "_SUCCESS"), {
                  actionType: action.type
                });
                store.dispatch(_objectSpread({
                  type: "".concat(action.type, "_SUCCESS"),
                  payload: result
                }, config));
                if (action.loadingKey) {
                  store.dispatch((0, _stopUILoading["default"])(action.loadingKey));
                }
              });
              return _context.a(2, next(action));
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
}
var _default = exports["default"] = apiMiddleware;
var NET_ERR_NOTIFICATION_TIMEOUT = 7000;
var notificationDisplayed = false;
var showNetworkErrorNotification = (0, _underscore.debounce)(function (dispatch) {
  dispatch((0, _showNotification["default"])('Your connection is unstable. We are detecting issues sending and retrieving updates.', {
    timeout: 7000,
    type: 'warning'
  }));
  notificationDisplayed = true;
  setTimeout(function () {
    notificationDisplayed = false;
  }, NET_ERR_NOTIFICATION_TIMEOUT);
}, 1000);